import { useTranslation } from 'react-i18next';
import { AVATARS } from '../constants/avatars';

export default function StudentsList({ students, onSelectStudent, isLoading = false }) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-24 mb-6"></div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="animate-pulse flex items-center gap-x-4 rounded-lg border border-gray-200 dark:border-gray-700 p-4">
              <div className="h-12 w-12 rounded-full bg-gray-200 dark:bg-gray-700"></div>
              <div className="space-y-3 flex-1">
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
                <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!Array.isArray(students)) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
        {t('students')}
      </h2>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {students.map((student, index) => (
          <button
            key={index}
            onClick={() => onSelectStudent(student.name)}
            className="flex items-center gap-x-4 rounded-lg border border-gray-200 dark:border-gray-700 p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors text-left w-full"
          >
            <img
              src={student.gender === 'Male' ? AVATARS.MALE : AVATARS.FEMALE}
              alt=""
              className="h-12 w-12 rounded-full bg-gray-100"
            />
            <div>
              <h3 className="text-sm font-medium text-gray-900 dark:text-white">
                {student.name}
              </h3>
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                {t('instructor')}: {student.instructor}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}